<template>
  <div>
    <el-dialog :visible.sync="dialogCodeVisible" top="2%" @close="handleCancel">
      <span slot="title">确认付药</span>
      <div class="pass-reject-box" v-loading="loading">
        <div class="pass-reject-title">
          <img
            class="pass-reject-title-icon"
            src="@/assets/confirmPay/tiaopei.png"
            alt=""
          />
          <span>调配</span>
        </div>
        <div class="pass-reject-content">
          <div
            :class="[
              'pass-reject-content-item',
              { isdisabled: !pharmacist.isEnabled },
              { active: pharmacist.openId === dispenseUser.openId },
            ]"
            v-for="pharmacist in onlinePharmacists"
            :key="pharmacist.openId"
            @click="handlePharmacistChange(pharmacist)"
          >
            <img
              v-if="
                pharmacist.openId === dispenseUser.openId &&
                pharmacist.isEnabled
              "
              class="pass-reject-content-item-icon"
              src="@/assets/passReject/check.png"
              alt=""
            />
            <div
              :class="[
                'pass-reject-content-item-title',
                { isdisabled: !pharmacist.isEnabled },
              ]"
            >
              <span>{{ pharmacist.realName }}</span>
              <span
                :class="[
                  'pass-reject-content-item-title-reason',
                  { lg: pharmacist.reason == '离岗' },
                ]"
                >{{ pharmacist.reason }}</span
              >
            </div>
            <div
              :class="[
                'pass-reject-content-item-content',
                { isdisabled: !pharmacist.isEnabled },
              ]"
            >
              到岗时间：{{ pharmacist.signedTime }}
            </div>
            <div
              :class="[
                'pass-reject-content-item-content',
                { isdisabled: !pharmacist.isEnabled },
              ]"
            >
              在岗时长：{{ pharmacist.signedLength }}
            </div>
          </div>
        </div>
        <div class="pass-reject-title">
          <img
            class="pass-reject-title-icon"
            src="@/assets/confirmPay/hedui.png"
            alt=""
          />
          <span>核对</span>
        </div>
        <div class="pass-reject-content">
          <div
            :class="[
              'pass-reject-content-item',
              { isdisabled: !pharmacist.isEnabled },
              { active: pharmacist.openId === checkUser.openId },
            ]"
            v-for="pharmacist in remotePharmacists"
            :key="pharmacist.openId"
            @click="handleRemotePharmacistChange(pharmacist)"
          >
            <img
              v-if="
                pharmacist.openId === checkUser.openId && pharmacist.isEnabled
              "
              class="pass-reject-content-item-icon"
              src="@/assets/passReject/check.png"
              alt=""
            />
            <div
              :class="[
                'pass-reject-content-item-title',
                { isdisabled: !pharmacist.isEnabled },
              ]"
            >
              <span>{{ pharmacist.realName }}</span>
              <span
                :class="[
                  'pass-reject-content-item-title-reason',
                  { lg: pharmacist.reason == '离岗' },
                ]"
                >{{ pharmacist.reason }}</span
              >
            </div>
            <div
              :class="[
                'pass-reject-content-item-content',
                { isdisabled: !pharmacist.isEnabled },
              ]"
            >
              到岗时间：{{ pharmacist.signedTime }}
            </div>
            <div
              :class="[
                'pass-reject-content-item-content',
                { isdisabled: !pharmacist.isEnabled },
              ]"
            >
              在岗时长：{{ pharmacist.signedLength }}
            </div>
          </div>
        </div>
        <div class="pass-reject-button">
          <el-button
            plain
            @click="handleCancel"
            size="mini"
            style="margin-right: 50px"
            >取消</el-button
          >
          <el-button
            type="primary"
            :disabled="!checkUser.openId || !dispenseUser.openId"
            size="mini"
            @click="handleSubmit"
            >提交</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ConfirmPay",
  components: {},
  props: {},
  data() {
    return {
      dialogCodeVisible: false,
      loading: false,
      onlinePharmacists: [],
      remotePharmacists: [],
      form: {},
      checkUser: {},
      dispenseUser: {},
    };
  },
  methods: {
    handleCancel() {
      this.onlinePharmacists = [];
      this.remotePharmacists = [];
      this.checkUser = {};
      this.dispenseUser = {};
      this.dialogCodeVisible = false;
    },
    async handleSubmit() {
      this.loading = true;
      await this.$api.prescription.AddCheckUsers({
        prescriptionId: this.form.id,
        checkUser: this.checkUser,
        dispenseUser: this.dispenseUser,
      });
      this.loading = false;
      this.dialogCodeVisible = false;
      this.$emit("submit");
    },
    handlePharmacistChange(val) {
      if (!val.isEnabled) return;
      this.dispenseUser = val;
    },
    handleRemotePharmacistChange(val) {
      if (!val.isEnabled) return;
      this.checkUser = val;
    },
    async show(row) {
      this.dialogCodeVisible = true;
      this.form = row;
      this.loading = true;
      const { data } = await this.$api.prescription.GetCheckUsers();
      this.onlinePharmacists = data || [];
      this.remotePharmacists = data || [];
      this.loading = false;
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
</style>
<style lang="scss" scoped>
@import "./confirmPay.scss";
</style>
